import ajax from '../http/ajax'

/**
 * 获取热门城市接口
 * @param {*} params 参数
 * @return 略
 */
export const getHotCityList = params => {
    return ajax.get('selectHotCity', params)
}

/**
 * 获取城市接口
 * @param {*} params 参数
 * @return 略
 */
export const getCityList = params => {
    return ajax.get('getCityList', params)
}

/**
 * 地址搜索
 * @param {*} params 参数
 * @return 略
 */
export const selectAddress = params => {
    return ajax.get('selectAddress', params)
}
